// see pro_controllers_helper.rb
enum PaymentMethodName {
    AmazonPay = 'Amazon Pay', // this is used as alt text do not change
    ApplePay = 'Apple Pay', // this is used as alt text do not change
    PayByCreditCard = 'payByCreditCard',
    PayPal = 'PayPal' // this is used as alt text do not change
  }

export default PaymentMethodName;